/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {MicroSiteUserSettings} from '../models/MicroSiteUserSettings';

export interface GetUserSettings$Request {
    accountId: number;
}

export interface GetUserSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserSettingsRequest = createAction<PayloadData<void, GetUserSettings$Request>>('USER_SETTINGS__GET_USER_SETTINGS__REQUEST');
export const getUserSettingsSuccess = createAction<PayloadData<MicroSiteUserSettings, GetUserSettings$Request>>('USER_SETTINGS__GET_USER_SETTINGS__SUCCESS');
export const getUserSettingsFailure = createAction<PayloadData<Error, GetUserSettings$Request, true>>('USER_SETTINGS__GET_USER_SETTINGS__FAILURE');

export const getUserSettingsActions = [
    getUserSettingsRequest,
    getUserSettingsSuccess,
    getUserSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserSettings = (meta: GetUserSettings$Request, config?: GetUserSettings$Config) => {
    return {
        CALL_API: {
            types: getUserSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/microsites/user-settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateUserSettings$Request {
    accountId: number;
    microSiteUserSettings: MicroSiteUserSettings;
}

export interface UpdateUserSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateUserSettingsRequest = createAction<PayloadData<void, UpdateUserSettings$Request>>('USER_SETTINGS__UPDATE_USER_SETTINGS__REQUEST');
export const updateUserSettingsSuccess = createAction<PayloadData<void, UpdateUserSettings$Request>>('USER_SETTINGS__UPDATE_USER_SETTINGS__SUCCESS');
export const updateUserSettingsFailure = createAction<PayloadData<Error, UpdateUserSettings$Request, true>>('USER_SETTINGS__UPDATE_USER_SETTINGS__FAILURE');

export const updateUserSettingsActions = [
    updateUserSettingsRequest,
    updateUserSettingsSuccess,
    updateUserSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {MicroSiteUserSettings} meta.microSiteUserSettings
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateUserSettings = (meta: UpdateUserSettings$Request, config?: UpdateUserSettings$Config) => {
    return {
        CALL_API: {
            types: updateUserSettingsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/microsites/user-settings`,
            TRANSPORT_REQUEST_BODY: meta.microSiteUserSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

